import { render, staticRenderFns } from "./VasConfigurableLoginModal.vue?vue&type=template&id=2bd27167"
import script from "./VasConfigurableLoginModal.vue?vue&type=script&lang=js"
export * from "./VasConfigurableLoginModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports